import React from 'react';
import { Navigate } from 'react-router-dom';
import RegistrationState from '@app/model/authentication/RegistrationState';
import SignInPage from '@app/site/authentication/page/SignInPage';
import useSiteState from '@app/state/SiteState';
import { useSearchParam } from 'react-use';

const AfterAuthenticationHandler = React.memo(() => {

	const [principal, token] = useSiteState(state => [state.principal, state.token]);

	const webhotelierId = useSearchParam('webhotelierId');

	if (!!principal && principal.isEnabled && !principal.isLocked)
		return <React.Fragment>
			{!!token && principal.registrationState === RegistrationState.COMPLETED && !!webhotelierId &&
				<Navigate replace to={"/secured/dashboard?webhotelierId=" + webhotelierId} />}
			{!!token && principal.registrationState === RegistrationState.COMPLETED && !webhotelierId &&
				<Navigate replace to={"/secured/dashboard"} />}
			{principal.registrationState !== RegistrationState.COMPLETED && !!webhotelierId &&
				<Navigate replace to={'/registration?webhotelierId=' + webhotelierId} />}
			{principal.registrationState !== RegistrationState.COMPLETED && !webhotelierId &&
				<Navigate replace to={'/registration'} />}
		</React.Fragment>;

	return <SignInPage />;
});

export default AfterAuthenticationHandler;